import { S } from '../../utils/constants';

/**
 * Form Input Component
 * @param {string} label - Input label
 * @param {string} type - Input type (text, password, email, etc.)
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Required field
 * @param {string} error - Error message
 * @param {object} style - Additional styles
 */
export function Input({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  required = false,
  error,
  style = {},
  ...props 
}) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label style={{
          color: "#4d6680",
          fontSize: 11,
          display: "block",
          marginBottom: 6,
          fontWeight: 700
        }}>
          {label}
          {required && <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: "100%",
          background: S.input,
          border: `1px solid ${error ? '#ef4444' : '#1a2540'}`,
          borderRadius: 10,
          padding: "10px 14px",
          color: S.txt,
          fontSize: 13,
          fontFamily: "'Cairo',sans-serif",
          outline: "none",
          boxSizing: "border-box",
          display: "block",
          ...style,
        }}
        {...props}
      />
      {error && (
        <p style={{ color: "#f87171", fontSize: 12, marginTop: 6, marginBottom: 0 }}>
          {error}
        </p>
      )}
    </div>
  );
}

/**
 * Textarea Component
 */
export function Textarea({ label, value, onChange, placeholder, rows = 4, ...props }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label style={{
          color: "#4d6680",
          fontSize: 11,
          display: "block",
          marginBottom: 6,
          fontWeight: 700
        }}>
          {label}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        style={{
          width: "100%",
          background: S.input,
          border: `1px solid #1a2540`,
          borderRadius: 10,
          padding: "10px 14px",
          color: S.txt,
          fontSize: 13,
          fontFamily: "'Cairo',sans-serif",
          outline: "none",
          boxSizing: "border-box",
          display: "block",
          resize: "vertical",
        }}
        {...props}
      />
    </div>
  );
}

/**
 * Select Component
 */
export function Select({ label, value, onChange, options, placeholder = 'اختر...', ...props }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label style={{
          color: "#4d6680",
          fontSize: 11,
          display: "block",
          marginBottom: 6,
          fontWeight: 700
        }}>
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          background: S.input,
          border: "1px solid #1a2540",
          borderRadius: 10,
          padding: "10px 14px",
          color: value ? S.txt : S.muted,
          fontSize: 13,
          fontFamily: "'Cairo',sans-serif",
          outline: "none",
          boxSizing: "border-box",
          display: "block",
          cursor: "pointer",
        }}
        {...props}
      >
        <option value="">{placeholder}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
